import urlSlug from "url-slug";
import { useHistory } from "react-router-dom";

import { Konkurs } from "../../models/Konkurs";
import styles from "./PremiumJobCard.module.scss";

// Assets
import defaultLogo from "../../assets/logos/logo.png";
import { ReactComponent as PremiumIcon } from "../../assets/icons/premium.svg";
import { useMemo } from "react";

interface PremiumJobCardProps {
  konkurs: Konkurs;
}

export const PremiumJobCard: React.FunctionComponent<PremiumJobCardProps> = ({
  konkurs,
}) => {
  const history = useHistory();

  const url = useMemo(() => {
    const path = urlSlug(konkurs.naslov);
    return "/posao/" + konkurs.id + "/" + path;
  }, [konkurs]);

  const onCardClick = () => {
    history.push(url);
  };

  const onLogoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(konkurs.urlPravnogLica ?? "/", "_blank");
  };

  return (
    <a
      href={url}
      tabIndex={0}
      className={styles.premiumJobCard}
      title={konkurs.naslov}
      onClick={onCardClick}
    >
      <div className={styles.tag}>
        <PremiumIcon />
        <p className={styles.tag__text}>premium</p>
      </div>

      <div className={styles.link} onClick={onLogoClick}>
        <img
          className={styles.logo}
          src={konkurs?.slika ?? defaultLogo}
          alt={konkurs?.naslov ?? "Logo"}
        />
      </div>
      <h3 className={styles.title}>{konkurs.naslov ?? ""}</h3>
      <div className={styles.location}>
        <div className={styles.icon} /> Lokacija:
        <span className={styles.span}> {konkurs?.lokacija ?? ""}</span>
      </div>
    </a>
  );
};
